module.exports = "/images/Minestore.png?9a5f5c873a3d0649b2a462d01468becb";